import { CheckCircle, Mail, Shield } from "lucide-react";
import { Card } from "@/components/common";
import { AvatarUpload } from "@/components/common/AvatarUpload";
import { useDeleteAvatar, useUploadAvatar } from "@/hooks/useSettings";
import type { UserProfile } from "@/types/settings";

interface SettingsSidebarProps {
  profile: UserProfile | undefined;
}

export function SettingsSidebar({ profile }: SettingsSidebarProps) {
  const uploadAvatar = useUploadAvatar();
  const deleteAvatar = useDeleteAvatar();

  const initials = profile
    ? `${profile.firstName[0]}${profile.lastName[0]}`
    : "?";

  function handleAvatarUpload(blob: Blob) {
    const fd = new FormData();
    fd.append("avatar", blob, "avatar.jpg");
    uploadAvatar.mutate(fd);
  }

  return (
    <aside className="hidden space-y-4 lg:block">
      {/* Profile card */}
      <Card>
        <div className="flex flex-col items-center text-center">
          <AvatarUpload
            currentAvatarUrl={profile?.avatarUrl ?? null}
            initials={initials}
            onUpload={handleAvatarUpload}
            onDelete={() => {
              deleteAvatar.mutate();
            }}
            isUploading={uploadAvatar.isPending || deleteAvatar.isPending}
          />

          <h2 className="mt-4 w-full break-words text-base font-semibold text-main">
            {profile?.firstName} {profile?.lastName}
          </h2>

          <div className="mt-1.5 flex w-full min-w-0 items-start justify-center gap-1.5 text-sm text-dim">
            <Mail size={14} className="mt-0.5 shrink-0" aria-hidden="true" />
            <span className="min-w-0 break-all">{profile?.email}</span>
          </div>
        </div>
      </Card>

      {/* Security status card */}
      <Card>
        <div className="flex items-center gap-2 text-sm font-semibold text-main">
          <Shield size={16} aria-hidden="true" />
          <span>Bezpieczeństwo</span>
        </div>

        <ul className="mt-3 space-y-2.5">
          <li className="flex items-center justify-between text-sm">
            <span className="text-sub">Email zweryfikowany</span>
            <CheckCircle
              size={16}
              className="text-emerald-500"
              aria-hidden="true"
            />
          </li>

          <li className="flex items-center justify-between text-sm">
            <span className="text-sub">Logowanie dwuetapowe</span>
            <CheckCircle
              size={16}
              className="text-emerald-500"
              aria-hidden="true"
            />
          </li>

        </ul>
      </Card>
    </aside>
  );
}
